module.exports = __webpack_public_path__ + "img/google-meet.8fa824cb.svg";